/**
 * Date-extensions locale Malay [ms]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('ms', {
    monthNames: ['Januari','Februari','Mac','April','Mei','Jun','Julai','Ogos','September','Oktober','November','Disember'],
    monthShortNames: ['Jan','Feb','Mac','Apr','Mei','Jun','Jul','Ogs','Sep','Okt','Nov','Dis'],
    dayNames: ['Ahad','Isnin','Selasa','Rabu','Khamis','Jumaat','Sabtu'],
    dayShortNames: ['Ahd','Isn','Sel','Rab','Kha','Jum','Sab']
});
